import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/common.css'
import App from './App.vue'
import axios from 'axios'
import router from './router'
import store from './store'
import $ from 'jquery'
import "./assets/css/font-size.css";
import SideFloatBar from "@/components/sideFloatBar.vue";   //右侧悬浮侧边栏
import Bus from "@/utils/bus";

import VueCompositionAPI from "@vue/composition-api";

// 全局注册组件
Vue.component('SideFloatBar', SideFloatBar)

Vue.config.productionTip = false
Vue.prototype.$axios = axios
window.$ = $
window.jQuery = $
// 供后台配置的 footer 链接 href="javascript:customerService();" 调用，
// 通过事件总线打开客服弹窗（customerService.vue 中监听 openCustomerService）
window.customerService = function () {
  Bus.$emit('openCustomerService')
}
// 引用环境变量，比如控制调试模式
if (process.env.NODE_ENV === 'development') {
  Vue.config.debug = true // 开发环境开启调试
} else {
  Vue.config.debug = false // 生产环境关闭调试
}
Vue.use(ElementUI);
Vue.use(VueCompositionAPI);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
